import { Theme } from "@mui/material/styles";
import { scsmsTokens as t } from "./brandTokens";

export function getComponentOverrides(theme: Theme) {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        html: { height: "100%" },
        body: {
          height: "100%",
          margin: 0,
          backgroundColor: t.color.neutral[50],
          color: t.color.neutral[800],
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
        },
        "#root": { minHeight: "100dvh", backgroundColor: t.color.neutral[50] },
        "*, *::before, *::after": { boxSizing: "border-box" },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: t.color.neutral[0],
          color: t.color.neutral[800],
          borderBottom: `1px solid ${t.color.neutral[200]}`,
          boxShadow: "none",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: t.color.secondary[500],
          color: t.color.neutral[0],
          borderRight: "none",
        },
      },
    },
    MuiCard: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          borderRadius: t.radius.lg,
          border: `1px solid ${t.color.neutral[200]}`,
          boxShadow: "0 10px 30px rgba(16, 33, 49, 0.06)",
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: t.radius.sm,
          textTransform: "none",
          fontWeight: 700,
          minHeight: 40,
          paddingInline: 16,
        },
        containedPrimary: {
          backgroundColor: t.color.primary[700],
          "&:hover": { backgroundColor: t.color.primary[800] },
        },
        outlined: {
          borderColor: t.color.neutral[300],
          color: t.color.neutral[800],
          "&:hover": {
            borderColor: t.color.primary[500],
            backgroundColor: t.color.primary[50],
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: { size: "small", variant: "outlined" },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: t.radius.sm,
          backgroundColor: t.color.neutral[0],
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: t.color.neutral[300],
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: t.color.secondary[400],
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderWidth: 1.5,
            borderColor: t.color.primary[500],
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: { borderRadius: t.radius.sm, fontSize: 14 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: t.radius.sm, fontWeight: 700 },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: t.radius.lg,
          border: `1px solid ${t.color.neutral[200]}`,
        },
      },
    },
    MuiDivider: {
      styleOverrides: { root: { borderColor: t.color.neutral[200] } },
    },
  };
}
